import React from 'react'
import ReactDOM from 'react-dom'

const TsxToHtml = (Component: any) => {
  const rootDom = document.createElement('div')
  ReactDOM.render(Component, rootDom)
  return rootDom.innerHTML
}

export default TsxToHtml
